import PageLayout from "@/components/layout/PageLayout";
import About from "@/components/sections/About";

export default function AboutPage() {
  return (
    <PageLayout testId="about-page">
      <About />
    </PageLayout>
  );
}
